import ServiceBase from './ServiceBase';

export default class InfoBannersService extends ServiceBase {
    getInfoBanners() {
        return this.request('get', 'infoBanners/getInfoBanners' );
    }
}
